export default "__VITE_ASSET__DWnk1VHf__"